import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';
import { SearchFooter } from '@atlassian/search-dialog';
import Button from '@atlaskit/button';
import { N20, N900 } from '@atlaskit/theme/colors';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var FeedbackLinkWrapper = styled.div({
  display: 'flex',
  justifyContent: 'center',
  backgroundColor: "var(--ds-background-neutral, ".concat(N20, ")"),
  padding: "var(--ds-space-050, 4px)".concat(" 0")
});

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var FeedbackLink = styled(Button)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\t&& {\n\t\ttext-decoration: underline;\n\t\t&:hover {\n\t\t\tcolor: ", " !important;\n\t\t}\n\t}\n"])), "var(--ds-link-pressed, ".concat(N900, ")"));
var searchFooterWrapperHeight = "var(--ds-space-1000, 80px)";

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var SearchFooterWrapper = styled(SearchFooter)({
  display: 'flex',
  flexDirection: 'column',
  height: searchFooterWrapperHeight
});